var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.79 27.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .7;\n      }\n\n      .cls-2 {\n        fill: #2d3e50;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.1,10.2v-3.4c0-3.75,3.04-6.8,6.8-6.8s6.8,3.04,6.8,6.8v3.4h1.7c1.87,0,3.4,1.52,3.4,3.4v10.2c0,1.87-1.52,3.4-3.4,3.4H3.4c-1.87,0-3.4-1.52-3.4-3.4v-10.2c0-1.87,1.52-3.4,3.4-3.4h1.7ZM2.55,13.59v10.2c0,.47.38.85.85.85h16.99c.47,0,.85-.38.85-.85v-10.2c0-.47-.38-.85-.85-.85H3.4c-.47,0-.85.38-.85.85ZM7.65,6.8v3.4h8.5v-3.4c0-2.35-1.9-4.25-4.25-4.25s-4.25,1.9-4.25,4.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconOutline);
export default __webpack_public_path__ + "static/media/lock_icon_outline.e62de6f2c9e09eaf303d7ac9c0cef5ae.svg";
export { ForwardRef as ReactComponent };